export const LocalStorageFields = {
  subscriptionPopupShown: "subscription.popup.shown",
}
